import template from "./scene-preview.html";
import {scenePreviewController} from "./scene-preview.controller";
import "./scene-preview.scss";

export const scenePreviewComponent = {
    template,
    controller: scenePreviewController,
    controllerAs: "scene",
    bindings: {
        layoutWidth: "<",
        layoutHeight: "<",
        sceneWidth: "<",
        sceneHeight: "<",
        photo: "<",
        overlayFiles: "<",
        backgroundFiles: "<",
        image: "<",
        photoIndex: "<",
        hidePhotoBg: "<",
        hideScene: "<"
    }
};


// WEBPACK FOOTER //
// ./sources/components/common/scene-preview/scene-preview.component.js